import React from 'react';
import { ProfessionalInfo } from '../../components/ProfessionalDetail/ProfessionalInfo';
import { BookingPanel } from '../../components/ProfessionalDetail/BookingPanel';
import styles from './ProfessionalPreview.module.scss';
import { useProfessionalPreview } from './hooks/useProfessionalPreview';
import Loading from '../../components/ui/Loading/Loading';

const ProfessionalPreview: React.FC = () => {
    const { previewData, systemSettings, loading, availability, availabilityLoading } = useProfessionalPreview();

    if (loading || availabilityLoading || !previewData) {
        return <Loading fullscreen />;
    }

    return (
        <div className={styles['preview-container'] + " container"}>
            

            <div className={styles['preview-content']}>
                <div className={styles['preview-content__info']}>
                    <ProfessionalInfo 
                        professional={previewData} 
                        studies={previewData.profile.studies}
                        aboutSettings={systemSettings?.about}
                        professionalInfoSettings={systemSettings?.professional_info} 
                    />
                </div>
                <div className={styles['preview-content__booking']}>
                    <BookingPanel
                        professionalUid={previewData.profile.uid}
                        availability={availability ?? []}
                        setIsBookingModalOpen={() => {}}
                        modality={previewData.profile.details?.consult_type || (previewData.profile.details as any)?.modality}
                        consultTime={previewData.profile.details?.consult_time}
                        consultPrice={previewData.profile.details?.consult_price || 0}
                        currency={previewData.profile.details?.currency || 'UYU'}
                        pricingMode={previewData.profile.details?.pricing_mode || 'single'}
                        initialPrice={previewData.profile.details?.initial_price || null}
                        initialDuration={previewData.profile.details?.initial_duration ? Number(previewData.profile.details.initial_duration) : null}
                        followupPrice={previewData.profile.details?.followup_price || null}
                        followupDuration={previewData.profile.details?.followup_duration ? Number(previewData.profile.details.followup_duration) : null}
                        bookingMode={previewData.profile.details?.booking_mode || 'direct'}
                        requestSchedule={previewData.profile.details?.request_schedule}
                        messagingEnabled={['1', 1, 'true', true].includes(previewData.profile.details?.messaging_enabled ?? true)}
                        professionalName={(previewData.profile.first_name || '') + ' ' + (previewData.profile.last_name || '')}
                        professionalPicture={previewData.profile.details?.image || null}
                        isOwnProfile={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default ProfessionalPreview;